// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_REQUEST_DK = 'FETCH_CUTTING_DC_REQUEST_DK';
export const FETCH_CUTTING_DC_SUCCESS_DK = 'FETCH_CUTTING_DC_SUCCESS_DK';
export const FETCH_CUTTING_DC_FAILURE_DK = 'FETCH_CUTTING_DC_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_STYLE_REQUEST_DK = 'FETCH_CUTTING_DC_STYLE_REQUEST_DK';
export const FETCH_CUTTING_DC_STYLE_SUCCESS_DK = 'FETCH_CUTTING_DC_STYLE_SUCCESS_DK';
export const FETCH_CUTTING_DC_STYLE_FAILURE_DK = 'FETCH_CUTTING_DC_STYLE_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_FORMAT_REQUEST_DK = 'FETCH_CUTTING_DC_FORMAT_REQUEST_DK';
export const FETCH_CUTTING_DC_FORMAT_SUCCESS_DK = 'FETCH_CUTTING_DC_FORMAT_SUCCESS_DK';
export const FETCH_CUTTING_DC_FORMAT_FAILURE_DK = 'FETCH_CUTTING_DC_FORMAT_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_CUTTING_DC_REQUEST_DK = 'CREATE_CUTTING_DC_REQUEST_DK';
export const CREATE_CUTTING_DC_SUCCESS_DK = 'CREATE_CUTTING_DC_SUCCESS_DK';
export const CREATE_CUTTING_DC_FAILURE_DK = 'CREATE_CUTTING_DC_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_CUTTING_DC_DK = 'CREATE_USER_FORM_CUTTING_DC_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_CUTTING_DC_REQUEST_DK = 'UPDATE_CUTTING_DC_REQUEST_DK';
export const UPDATE_CUTTING_DC_SUCCESS_DK = 'UPDATE_CUTTING_DC_SUCCESS_DK';
export const UPDATE_CUTTING_DC_FAILURE_DK = 'UPDATE_CUTTING_DC_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_CUTTING_DC_REQUEST_DK = 'FETCH_SINGLE_CUTTING_DC_REQUEST_DK';
export const FETCH_SINGLE_CUTTING_DC_SUCCESS_DK = 'FETCH_SINGLE_CUTTING_DC_SUCCESS_DK';
export const FETCH_SINGLE_CUTTING_DC_FAILURE_DK = 'FETCH_SINGLE_CUTTING_DC_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_CUTTING_DC_REQUEST_DK = 'DELETE_CUTTING_DC_REQUEST_DK';
export const DELETE_CUTTING_DC_SUCCESS_DK = 'DELETE_CUTTING_DC_SUCCESS_DK';
export const DELETE_CUTTING_DC_FAILURE_DK = 'DELETE_CUTTING_DC_FAILURE_DK';

// USERFORM RESET

export const CUTTING_DC_USERFORM_RESET_DK = 'CUTTING_DC_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_CUTTING_DC_DETAILS_DK = 'NAVIGATE_CUTTING_DC_DETAILS_DK';
// navigate to company component
export const NAVIGATE_CUTTING_DC_DK = 'NAVIGATE_CUTTING_DC_DK';
export const CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_INVOICE_REQUEST = 'FETCH_CUTTING_DC_INVOICE_REQUEST';
export const FETCH_CUTTING_DC_INVOICE_SUCCESS = 'FETCH_CUTTING_DC_INVOICE_SUCCESS';
export const FETCH_CUTTING_DC_INVOICE_FAILURE = 'FETCH_CUTTING_DC_INVOICE_FAILURE';

export const RESET_CUTTING_DC_INVOICE = 'RESET_CUTTING_DC_INVOICE';

export const FETCH_CUTTING_DC_PRINTING_LIST_REQUEST_DK = 'FETCH_CUTTING_DC_PRINTING_LIST_REQUEST_DK';

export const FETCH_CUTTING_DC_PRINTING_LIST_SUCCESS_DK = 'FETCH_CUTTING_DC_PRINTING_LIST_SUCCESS_DK';

export const FETCH_CUTTING_DC_PRINTING_LIST_FAILURE_DK = 'FETCH_CUTTING_DC_PRINTING_LIST_FAILURE_DK';

export const RESET_PRINT_DATA_FOR_EDIT_CUTTING = 'RESET_PRINT_DATA_FOR_EDIT_CUTTING';

export const DELETE_BTN_UPDATE_API_REQUEST_DK = 'DELETE_BTN_UPDATE_API_REQUEST_DK';
export const DELETE_BTN_UPDATE_API_SUCCESS_DK = 'DELETE_BTN_UPDATE_API_SUCCESS_DK';
export const DELETE_BTN_UPDATE_API_FAILURE_DK = 'DELETE_BTN_UPDATE_API_FAILURE_DK';
